import * as React from 'react';

import { Table } from 'semantic-ui-react';

import { localeData } from '../../locales/data';
import { addModifiers } from '../../shared/helpers';
import { FormattedMessageHelper } from '../../shared/helpers/internationalization';

interface AlphaDataTableProps {
  data?: any;
  modifiers?: string[];
  lowerCaseValues?: any;
  typeStage?: string;
  settingsOptions?: any;
  tableRowsRecords?: any;
  tableRowsProperties?: any;
  stagePerformanceColumnsTypes?: any;
  dataType?: any;
}

interface RenderHeaderValueProps {
  typeStage?: string;
  value: any;
}

const RenderHeaderValue = ({ typeStage, value }: RenderHeaderValueProps) => (
  <React.Fragment>
    {!typeStage ? (
      <span>{value.title || value}</span>
    ) : (
      <FormattedMessageHelper tagName="span" id={value.title || value} defaultMessage={localeData.en[value.title || value]} />
    )}
  </React.Fragment>
);

export const isNumberType = (type: string, dataTypeIndex?: string, column?: string) => {
  if (
    type === 'decimal' ||
    type === 'percent' ||
    type === 'decimal' ||
    type === 'permyriad' ||
    type === 'amount' ||
    type === 'integer' ||
    dataTypeIndex === 'number' ||
    column === 'Delay'
  ) {
    return 'summary-table-cell-right';
  } else {
    return 'summary-table-cell-left';
  }
};

export const AlphaDataTable = ({
  tableRowsRecords,
  tableRowsProperties,
  stagePerformanceColumnsTypes,
  dataType,
  modifiers = [],
  lowerCaseValues = [],
  typeStage,
}: AlphaDataTableProps) => {
  let lowerCaseValuesIndex: any = [];
  const getISIndex = (propertyId: string) => tableRowsProperties.findIndex((property: any) => property.id === propertyId);
  const stageIndex = tableRowsProperties ? getISIndex('stage') : null;
  const stageArray = tableRowsRecords ? tableRowsRecords.map((record: any) => record[stageIndex]) : null;

  return (
    <Table size="small" className="summary-table">
      <Table.Header>
        <Table.Row className={addModifiers('summary-table-head', modifiers)}>
          {tableRowsProperties &&
            tableRowsProperties.map((value: any, index: number) => {
              if (value.title !== 'alphaSummary.stage') {
                lowerCaseValuesIndex = lowerCaseValues.includes(value) ? lowerCaseValuesIndex.concat(index) : lowerCaseValuesIndex;
                const type = stagePerformanceColumnsTypes[index];
                const className = isNumberType(type, dataType[index], value);

                return (
                  <Table.HeaderCell key={index} className={className}>
                    {value && <RenderHeaderValue value={value} typeStage={typeStage} />}
                  </Table.HeaderCell>
                );
              }
            })}
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {tableRowsRecords &&
          tableRowsRecords.map((line: any, indexLine: number) => (
            <Table.Row
              key={indexLine}
              className={`${addModifiers('summary-table-body', modifiers)}${
                stageArray[indexLine] ? ` stage-${stageArray[indexLine]}` : ''
              }`}
            >
              {tableRowsProperties.map((val: any, indexVal: number) => {
                const type = stagePerformanceColumnsTypes[indexVal];
                const className = isNumberType(type, dataType[indexVal], val);
                if (val.id !== 'stage') {
                  return (
                    <Table.Cell key={indexVal} className={className}>
                      {typeStage === 'is'
                        ? getISIndex(val.id) !== undefined &&
                          lowerCaseValuesIndex.includes(indexVal) &&
                          typeof line[getISIndex(val.id)] === 'string'
                          ? line[getISIndex(val.id)]
                          : line[getISIndex(val.id)]
                        : lowerCaseValuesIndex.includes(indexVal) && typeof line[indexLine][indexVal] === 'string'
                        ? line[indexLine][indexVal]
                        : line[indexLine][indexVal]}
                    </Table.Cell>
                  );
                }
              })}
            </Table.Row>
          ))}
      </Table.Body>
    </Table>
  );
};
